module.exports = __webpack_public_path__ + "img/trash.ec28fa71.svg";